import { render, staticRenderFns } from "./LiveChatList.vue?vue&type=template&id=6537429a&scoped=true&"
import script from "./LiveChatList.vue?vue&type=script&lang=js&"
export * from "./LiveChatList.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatList.vue?vue&type=style&index=0&id=6537429a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537429a",
  null
  
)

export default component.exports